import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { CompleteProfileFlowControllerPage } from './complete-profile-flow-controller.page';

const routes: Routes = [
  {
    path: '',
    component: CompleteProfileFlowControllerPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CompleteProfileFlowControllerPageRoutingModule {}
